var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWbgProteinV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#FCE4E9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6308 11.8271C18.022 9.06599 20.7618 9.99985 20.7924 10.0084C20.8386 10.0262 20.8784 10.0582 20.9062 10.1001C21.1885 10.6023 21.3635 11.1599 21.4161 11.7332L21.4368 12.7097C21.323 13.7439 20.9239 14.7261 20.2852 15.5483C20.4005 16.2212 20.3706 16.9104 20.1978 17.5697C20.0263 18.229 19.717 18.845 19.2895 19.377C19.2618 19.4125 19.2226 19.4381 19.1785 19.4517C19.1359 19.4659 19.0896 19.4659 19.0462 19.4531C19.0029 19.441 18.963 19.4161 18.9339 19.3812C18.9047 19.3471 18.8862 19.3044 18.8812 19.2596C18.7923 18.6458 18.5299 18.069 18.1245 17.5974C17.1593 18.261 16.1116 18.7973 15.0078 19.1928C15.081 19.702 15.0476 20.2212 14.9082 20.7177C14.7709 21.2141 14.5305 21.6757 14.2055 22.0747C14.1785 22.1046 14.1429 22.126 14.1052 22.1388C14.0675 22.1516 14.027 22.1537 13.9871 22.1452C13.9466 22.1388 13.9103 22.1224 13.879 22.0975C13.847 22.0719 13.8235 22.0392 13.8079 22.0022C13.672 21.5826 13.2353 20.4211 12.8399 20.106C12.4423 19.7895 11.2132 19.6224 10.7644 19.5896C10.7239 19.584 10.6869 19.5676 10.6556 19.5427C10.6243 19.5171 10.5994 19.4844 10.5852 19.4467C10.5689 19.409 10.5632 19.367 10.5682 19.3258C10.5731 19.2845 10.5902 19.2454 10.6158 19.2134C10.9309 18.8066 11.3271 18.4694 11.7801 18.2233C12.2332 17.978 12.7303 17.8286 13.2446 17.7866C13.2737 17.5839 13.3015 17.3656 13.3406 17.1323L13.5533 16.1017C13.6962 15.5192 13.8797 14.9473 14.1016 14.3911C13.5533 14.1031 12.9331 13.9772 12.3164 14.0277C12.2723 14.0326 12.2261 14.0248 12.1855 14.0028C12.145 13.9814 12.1116 13.9494 12.0909 13.9096C12.0682 13.8698 12.0589 13.825 12.0618 13.7794C12.066 13.7346 12.0824 13.6913 12.1101 13.6557C12.534 13.1187 13.0668 12.6777 13.6727 12.3626C14.2816 12.0468 14.9487 11.8648 15.6308 11.8271Z",
    fill: "#FC4871",
    stroke: "#FC4871",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7736 13.6627C19.2437 13.6357 18.7288 13.4394 18.307 13.103C17.8845 12.7666 17.5787 12.3085 17.4336 11.7979",
    stroke: "#FFECF1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWbgProteinV2);
export default __webpack_public_path__ + "static/media/wbg-protein-v2.e675faaa0766639bbd1a8d6108b28f73.svg";
export { ForwardRef as ReactComponent };